import { differenceInHours, isSameDay } from 'date-fns';

const getExpiresInfo = (todayDate, endDate) => {

  const expiresHours = differenceInHours(endDate, todayDate);

  const expiresToday = expiresHours >= 0 && expiresHours < 24;
  const expiresSoon = expiresHours >= 24 && expiresHours < 72;
  const expiresSameDay = isSameDay(endDate, todayDate);

  return {
    expiresHours,
    expiresToday,
    expiresSoon,
    expiresSameDay,
  };
};
export default getExpiresInfo;
